module.exports = __webpack_public_path__ + "img/xb_app.c00c7543.png";